import { BuilderMode, MealBuilderItemSection, SelectableVariantMenuItem, ZeroVariantBuilderMode } from '@/models';

import { AbstractMealBuilderItemVariantService } from '../../meal-builder-variant.service';

export class AppZeroVariantMealBuilderService extends AbstractMealBuilderItemVariantService<ZeroVariantBuilderMode> {
  selectVariantSafe() {
    throw new Error('Cannot select a variant with a zero-variant builder type!');
  }

  toggleVariantCustomizationSafe() {
    throw new Error('Cannot select a variant customization with a zero-variant builder type!');
  }

  getItemSections(builderMode: ZeroVariantBuilderMode, variant: SelectableVariantMenuItem | null) {
    const groupNames = Object.keys(builderMode.categories);
    const itemSections = groupNames.map(itemCategory => {
      const sectionItems = builderMode.categories[itemCategory];

      return <MealBuilderItemSection>{
        id: itemCategory,
        title: itemCategory,
        hidden: false,
        maxQuantity: null,
        maxCustomizations: null,
        items: sectionItems,
      };
    });

    return itemSections;
  }

  getVariants(builderMode: ZeroVariantBuilderMode) {
    return [];
  }

  getVariantsItemSectionTitle(mode: BuilderMode) {
    return '';
  }

  getVariantsItemSectionSubtitle(mode: BuilderMode, variant: SelectableVariantMenuItem): string | undefined {
    return;
  }

  getDefaultVariant(builderMode: ZeroVariantBuilderMode): SelectableVariantMenuItem | undefined {
    return;
  }

  validateMealBuilder(mode: ZeroVariantBuilderMode) {
    if (!this.store.state.mealBuilder.selectedItems.length) {
      return { error: `Select an item to get started` };
    }

    return { error: null };
  }
}
